var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex cursor--pointer",
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.icon
        ? _c("em", {
            staticClass: "mt-1 mr-3",
            class: `${_vm.icon} color-${
              _vm.colorIcon ? _vm.colorIcon : _vm.color
            }`
          })
        : _vm._e(),
      _c(
        "span",
        {
          class: [
            `text-border__bottom--${_vm.color}`,
            { "border-bottom": _vm.withBorder },
            _vm.textColor
          ]
        },
        [_vm._v(" " + _vm._s(_vm.text) + " ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }